import { AppLauncher } from "@capacitor/app-launcher";
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { useUIContext } from "./UIContext";
import "./UIContextCss.css";

export const checkInstagram = async () => {
  let instagramScheme = "com.instagram.android";
  if (Capacitor.getPlatform() === "ios") {
    instagramScheme = "instagram://";
  }
  const canOpen = await AppLauncher.canOpenUrl({ url: instagramScheme });
  return canOpen.value && Capacitor.isNativePlatform();
};

export const checkWhatsapp = async () => {
  const whatsappScheme = "com.whatsapp";
  const canOpen = await AppLauncher.canOpenUrl({ url: whatsappScheme });
  return canOpen.value && Capacitor.isNativePlatform();
};

export const checkNativeShare = async () => {
  return (await Share.canShare()).value;
};

export const DarkModeButton = () => {
  const { darkMode, toggleDarkMode } = useUIContext();
  return (
    <div className="toggle-switch cursor-pointer flex h-[18px] w-[18px] items-center justify-center text-[var(--inyc-secondary)] invert-[var(--inyc-lighten-white)]">
      <label
        htmlFor="themeToggle"
        className="themeToggle st-sunMoonThemeToggleBtn block w-full h-full"
        type="checkbox"
      >
        <input
          checked={darkMode}
          onChange={toggleDarkMode}
        type="checkbox" id="themeToggle" className="themeToggleInput" />
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="none"
        >
          <mask id="moon-mask">
            <rect x="0" y="0" width="20" height="20" fill="white"></rect>
            <circle cx="11" cy="3" r="8" fill="black"></circle>
          </mask>
          <circle
            className="sunMoon"
            cx="10"
            cy="10"
            r="8"
            mask="url(#moon-mask)"
          ></circle>
          <g>
            <circle className="sunRay sunRay1" cx="18" cy="10" r="1.5"></circle>
            <circle className="sunRay sunRay2" cx="14" cy="16.928" r="1.5"></circle>
            <circle className="sunRay sunRay3" cx="6" cy="16.928" r="1.5"></circle>
            <circle className="sunRay sunRay4" cx="2" cy="10" r="1.5"></circle>
            <circle className="sunRay sunRay5" cx="6" cy="3.1718" r="1.5"></circle>
            <circle className="sunRay sunRay6" cx="14" cy="3.1718" r="1.5"></circle>
          </g>
        </svg>
      </label>
    </div>
  );
};
